import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Row, Col, Input, Icon } from 'antd';
import { connect } from 'dva';
import { CancelToken } from 'axios';
import { SelectInput } from '../../../../index';
import helpers from '../../../../../utils/helpers';
import styles from '../styles.less';
import RemoteSelectInput from '../../../../common/DataEntry/RemoteSelectInput';

const FormItem = Form.Item;
const Search = Input.Search;

function ContactPersonFilters({ dispatch, getFieldsValue, getFieldDecorator, setFieldsValue, data, countries, filterChange, intl, companyName, companyDomain, companies }) {
  const [isAllFilters, setIsAllFilters] = useState(false);

  const loadCompanies = (query) => {
    let cancel;
    const requestConfig = {
      cancelToken: new CancelToken((c) => {
        cancel = c;
      }),
    };

    const request = dispatch({
      type: 'leadContact/loadCompanies',
      payload: {
        companyName: query,
        requestConfig,
      },
    }).then((result) => {
      if (!result || !Array.isArray(result.body)) {
        return {
          body: [],
        };
      }
      if (query.toLowerCase() === companyName.toLowerCase()) {
        const { defaultCompaniesCount } = getFieldsValue();
        if (defaultCompaniesCount === null && !companyDomain && result.body.length === 1) {
          setFieldsValue({
            filter_company: result.body[0].id,
            companySelected: result.body[0],
          });
          filterChange();
        }
        setFieldsValue({ defaultCompaniesCount: result.body.length });
      }
      return result;
    });

    return {
      request,
      cancel,
    };
  };

  return (
    <React.Fragment>
      <Row className={styles.filterHeader} type="flex" justify="space-between" >
        <Col>
          <FormattedMessage id={'Component.CreateHubspotTask.Form.SelectPerson.Label'} />
        </Col>
        <Col>
          <span className={styles.peopleFilterShow} onClick={() => setIsAllFilters(prev => !prev)}>
            {isAllFilters ?
              <Icon type="close" style={{ marginRight: 4 }} /> : <i className={styles.iconFilters} />
            }
            <FormattedMessage id={`Component.CreateHubspotTask.Form.Filter.${isAllFilters ? 'ShowLess' : 'ShowAll'}`} />
          </span>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Company">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_company', {
                  initialValue: data.filter_company,
                })(
                  <RemoteSelectInput
                    allowClear
                    style={{ width: '100%' }}
                    optionsKey="body"
                    idKey="id"
                    nameKey="name"
                    remoteLoader={loadCompanies}
                    showArrow
                    notFoundContent={intl.formatMessage({ id: 'Component.CreateHubspotTask.Form.Filter.NoCompaniesFound' })}
                    defaultQuery={companyDomain || 'filter_company' in data ? '' : companyName}
                    placeholder={msg}
                    onChange={filterChange}
                    initialOptions={companies}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Domain">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_domain', {
                  initialValue: 'filter_domain' in data ? data.filter_domain : companyDomain,
                })(
                  <Search
                    maxLength={255}
                    placeholder={msg}
                    onSearch={filterChange}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Country">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_country', {
                  initialValue: data.filter_country,
                })(
                  <SelectInput
                    allowClear
                    placeholder={msg}
                    filterOption={helpers.multipleSelectFilter}
                    options={countries}
                    idKey="id"
                    nameKey="name"
                    onChange={filterChange}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
      </Row>
      <Row
        style={{ display: isAllFilters ? 'block' : 'none' }}
        gutter={12}
      >
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Keyword">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_keyword', {
                  initialValue: data.filter_keyword,
                })(
                  <Search
                    maxLength={255}
                    placeholder={msg}
                    onSearch={filterChange}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Title">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_title', {
                  initialValue: data.filter_title,
                })(
                  <Search
                    maxLength={255}
                    placeholder={msg}
                    onSearch={filterChange}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col xs={8}>
          <FormattedMessage id="Component.CreateHubspotTask.Form.Filter.Seniority">
            {msg => (
              <FormItem colon={false}>
                {getFieldDecorator('filter_seniority', {
                  initialValue: data.filter_seniority,
                })(
                  <Search
                    maxLength={255}
                    placeholder={msg}
                    onSearch={filterChange}
                  />,
                )}
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
      </Row>
    </React.Fragment>
  );
}

ContactPersonFilters.propTypes = {
  getFieldDecorator: PropTypes.func,
  data: PropTypes.object,
  countries: PropTypes.array,
  filterChange: PropTypes.func,
  companyName: PropTypes.string,
  companyDomain: PropTypes.string,
  companies: PropTypes.array,
  setFieldsValue: PropTypes.func,
  getFieldsValue: PropTypes.func,
};

export default connect()(injectIntl(ContactPersonFilters));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/ContactPersonFilters.js